import { render, staticRenderFns } from "./Sospese.vue?vue&type=template&id=bd0af1b0&"
import script from "./Sospese.vue?vue&type=script&lang=js&"
export * from "./Sospese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports